import { differenceInCalendarDays, parseISO } from 'date-fns';

export interface ProjectTimelineTaskEvent {
  id: string;
  projectId: string;
  title: string;
  startDate: string;
  endDate: string;
  status?: string;
  /** Drives timeline bar tint when present */
  priority?: 'low' | 'medium' | 'high' | 'extreme' | 'ultra';
  assigneeNames: string[];
  /** Shown in multi-project timeline rows */
  projectTitle?: string;
  /** True when task (or all assignees, if independent progress) is completed or finished */
  timelineDone?: boolean;
}

interface RawProjectTask {
  id: string;
  projectId: string;
  title: string;
  status?: string;
  priority?: string;
  dueDate?: string;
  startDate?: string;
  endDate?: string;
  assignees?: { id: string; firstName: string; lastName: string }[];
}

export function adaptTasksToTimelineEvents(tasks: RawProjectTask[]): ProjectTimelineTaskEvent[] {
  return tasks
    .filter((task) => task.dueDate || task.startDate || task.endDate)
    .map((task) => {
      const rawStart = task.startDate || task.dueDate || task.endDate!;
      const rawEnd = task.endDate || task.dueDate || task.startDate!;

      let start = parseISO(rawStart);
      let end = parseISO(rawEnd);

      if (differenceInCalendarDays(end, start) < 0) {
        [start, end] = [end, start];
      }

      if (differenceInCalendarDays(end, start) === 0) {
        end = new Date(end);
        end.setDate(end.getDate() + 1);
      }

      const assigneeNames =
        task.assignees?.map((a) => `${a.firstName} ${a.lastName}`) ?? [];

      const pr = task.priority;
      const priority =
        pr === 'low' || pr === 'medium' || pr === 'high' || pr === 'extreme' || pr === 'ultra'
          ? pr
          : undefined;

      return {
        id: task.id,
        projectId: task.projectId,
        title: task.title,
        startDate: start.toISOString(),
        endDate: end.toISOString(),
        status: task.status,
        priority,
        assigneeNames
      };
    });
}
